<section class="prices">

  <h2 id="product-prices-title" class="container">Preços</h2>

  <div class="price-table">

    <ng-container *ngFor="let item of data.prices; let i = index;">
      <ng-container *ngIf="i === 0">
        <div>
          <strong class="title">&nbsp;</strong>
          <a>&nbsp;</a>

          <div class="parcel" *ngFor="let item of item.value.installments">
            {{item.type}}
            <img *ngIf="item.type === 'Chaves/Financiamento'" class="info-icon"
              src="/assets/svgs/product-details/info.svg" alt="alerta">
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngFor="let item of data.prices; let i = index;">
      <ng-container *ngIf="i === 0">
        <div>
          <strong class="title">&nbsp;</strong>
          <a>&nbsp;</a>
          <div class="parcel" *ngFor="let item of item.value.installments">
            {{item.times}}x
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngFor="let item of data.prices">
      <div>
        <strong class="title">{{item.area}}m²</strong>
        <a>Veja mês a mês</a>

        <div class="parcel" *ngFor="let parcel of item.value.installments">
          A partir de {{parcel.value.currency}} {{parcel.value.value | number : '1.2'}}
        </div>

        <strong class="value">
          {{item.value.currency}} {{item.value.value | number : '1.2'}}
        </strong>
      </div>

    </ng-container>

  </div>
</section>